import { httpClient } from '@/app/libs';
import { UserMapper } from '@/app/mappers/UserMapper';
import { IUser, Usuario } from '@/app/models/user';

type MeResponse = { result: Usuario };

export async function me(token: string): Promise<IUser> {
  const { result } = await httpClient.get<MeResponse>('/auth', {
    safeErrorStatus: [401],
    headers: { Authorization: `Bearer ${token}` },
  });

  const user = UserMapper.toDomain(result);

  return user;
}
